import type { Editor } from "grapesjs";
import type { TemplateId } from "../../../templates/types/templates-ids.types";
import { TEMPLATES } from "../../../templates/loader";

export function loadTemplate(editor: Editor, templateId: TemplateId): void {
  const tpl = TEMPLATES.find((t) => t.id === templateId) || TEMPLATES[0];

}
